import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  gap: 8px;
`

export const Code = styled.input`
  width: 60px;
  height: 64px;
  border: none;
  font-size: 20px;
  border-radius: 8px;
  text-align: center;
  border: 1px solid #d9d9d9;
  background: #fcfcfd;
  box-shadow: 0px 35px 63px -5px #a31e662b;
`
